import React, { Component } from 'react';
import { connect } from 'react-redux';
import Script from './Script';

class Pixel extends Component {

  render() {
    const { website } = this.props;
    return (
      <div className='ibox'>
          <div className='ibox-title'>
            <h5>Pixel</h5>      
          </div>
          <div className='ibox-content'>
            <Script website={website} />
          </div>
      </div>
    );
  }
}

export default connect()(Pixel);
